// @flow
import React from 'react';
// Components
import { ProgressiveImageLoader } from '../../../common';
// Helpers
import {
  scaleConverter,
  priceConverter,
  quantityConverter,
} from '../../../common';
// Styles
import './ResumeItem.css';
// Types
import type { Blend } from '../types';
// Constants
import { fatLevels } from '../../constants/fatLevels';

type Props = {
  blend: Blend,
};

const ResumeBlend = ({ blend }: Props) => {
  const itemWithImage = blend.lineItems?.find(
    item => item.variant?.images && item.variant.images.length > 0,
  );
  const productImage = itemWithImage ? itemWithImage.variant.images[0] : null;

  const firstLineItem = blend.lineItems && blend.lineItems[0];
  const unit = firstLineItem ? firstLineItem.variant.unitForQuantity : 'un';

  const price = scaleConverter(blend.price, unit);

  const portioningSize = blend.portioningSize;
  const quantity = blend.quantity;
  const portionNumber = portioningSize
    ? Math.floor(quantity / portioningSize)
    : 0;
  let remainder = portioningSize
    ? quantity - portioningSize * portionNumber
    : 0;

  const unitForQuantityPortioning = portioningSize >= 1000 ? 'Kg' : 'gramas';
  const unitForQuantityRemainder = remainder >= 1000 ? 'Kg' : 'gramas';

  const portioningSizeValue =
    portioningSize >= 1000 ? portioningSize / 1000 : portioningSize;
  remainder = remainder >= 1000 ? remainder / 1000 : remainder;

  return (
    <div className="resume-item-wrapper">
      <section className="resume-item-image-section">
        <div className="resume-item-link">
          <ProgressiveImageLoader
            selectedImage={productImage}
            imageToShow="product"
          />
        </div>
        <div className="resume-item-link">
          <p className="resume-item-variant">Blend</p>
          <h3 title={blend.name} className="resume-item-title">
            {blend.name}
          </h3>
        </div>
      </section>

      <section className="resume-item-info-section">
        <div className="resume-item-info-row">
          <div className="resume-item-info-row-title">
            Preço/{unit === 'g' || unit === 'kg' ? 'Kg' : 'un'}
          </div>
          <div className="resume-item-info-row-text">
            {priceConverter(price)}
          </div>
        </div>

        <div className="resume-item-info-row">
          <div className="resume-item-info-row-title">Quantidade</div>
          <span className="resume-item-info-row-quantity">
            {quantityConverter(quantity, unit)}
          </span>
        </div>

        <div className="resume-item-info-row">
          <div className="resume-item-info-row-title">Nível de Gordura</div>
          <span className="resume-item-info-row-quantity">
            {blend.fatPercentage
              ? `${blend.fatPercentage}%`
              : fatLevels[blend.fatLevel] || 'Padrão'}
          </span>
        </div>

        <div className="resume-item-info-row">
          <div className="resume-item-info-row-title">Embalagem a Vácuo</div>
          <span className="resume-item-info-row-quantity">Não</span>
        </div>

        <div className="resume-item-info-row">
          <div className="resume-item-info-row-title">Porcionamento</div>
          <span className="resume-item-info-row-quantity">
            {portioningSize && portioningSize !== quantity ? 'Sim' : 'Não'}
          </span>
        </div>

        <div className="resume-item-portioning-info">
          {!!portioningSize && portioningSize !== quantity && (
            <>
              {portionNumber} embalagem de {portioningSizeValue}{' '}
              {unitForQuantityPortioning}
              {remainder > 0 && (
                <>
                  {' '}
                  + 1 embalagem de {remainder} {unitForQuantityRemainder}{' '}
                </>
              )}
            </>
          )}
        </div>

        <div className="resume-item-info-row">
          <h3 title={blend.name} className="resume-item-title">
            Preço Estimado
          </h3>
          <div className="resume-item-text-price">
            {parseFloat(blend.total).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
        </div>
        <div className="resume-item-info-row" />
      </section>
    </div>
  );
};

export default ResumeBlend;
